import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {
  Link, NavLink, useNavigate, useSearchParams,
} from 'react-router';
import { intlShape } from '../components/base/IntlProviderWrapper';
import TooltipWithPortal from '../components/base/Tooltip/TooltipWithPortal';
import {
  APPLICATION_STATUS_NAMES,
  CARRIER_STATUS_NAMES,
  CHECK_STATUS_NAMES,
  DOCUMENT_STATUS_NAMES,
  CHECK_STATUS,
  SZLT_STATUS_NAMES,
  USER_TYPE,
  VEHICLES_STATUS_NAMES,
  SUBJECT_TYPE,
  REGISTRY_TYPE, APPLICATION_SUBJECT_TYPES, CARRIER_SUBJECT_TYPES, STATUS_NAMES,
  DOCUMENT_STATUS, DICT_VEHICLE_STATUS_NAMES, APPLICANT_STATUS, IN_REQUEST_INF_STATUS, VIOLATION_STATUS,
  NOTIFICATION_TYPE,
} from '../configs';
import {
  getExt, getFieldValidation, getKeyByValue, propsToRow, RegNumEnToRu,
} from './utils';
import { Col, Icons } from '../components/base/BootstrapComponents/BootstrapComponents';

export const optionClassFormatter = item => {
  let status = item;
  if (typeof item === 'object') {
    status = item.value;
  }
  return 'unknown-state';
};

export const dateFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a || typeof a === 'undefined') {
    return '';
  }
  let d = a;
  if (typeof a === 'string') {
    const m = moment(a);
    if (!m.isValid()) {
      return a;
    }
    d = m.toDate();
  }
  return formatDate(d, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const timeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
};

export const lastTimeFormatter = date => {
  if (!date) {
    return '';
  }

  const now = moment();
  const targetDate = moment(date);

  const diffMinutes = now.diff(targetDate, 'minute');

  if (targetDate.diff(now, 'day') || diffMinutes >= 60) {
    return '> 1 часа';
  }

  if (diffMinutes <= 30 && diffMinutes > 1) {
    return '≈ 30 мин';
  } if (diffMinutes > 30 && diffMinutes < 60) {
    return '> 30 мин ';
  } if (diffMinutes <= 1) {
    return '≈ 1 мин';
  }
};

export const tooltipFormatter = a => {
  if (!a) {
    return '';
  }
  return <TooltipWithPortal className="tooltip-formatter" content={a} />;
};

export const dateTimeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a || typeof a === 'undefined') {
    return '';
  }
  const date = formatDate(a, { year: 'numeric', month: 'numeric', day: 'numeric' }).replace(',', ' ');
  const time = formatDate(a, { hour: 'numeric', minute: 'numeric', second: 'numeric' }).replace(',', ' ');

  return (<div className="dt-formatter"><div className="dt-date">{date}</div><div className="dt-time">{time}</div></div>);
};

export const dateTimeStringFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a || typeof a === 'undefined') {
    return '';
  }
  const date = formatDate(a, { year: 'numeric', month: 'numeric', day: 'numeric' }).replace(',', ' ');
  const time = formatDate(a, { hour: 'numeric', minute: 'numeric', second: 'numeric' }).replace(',', ' ');

  return `${date} ${time}`;
};

export const menuAfterIcon = () => (
  <div className="after-button ms-auto"><Icons customIcon icon="square" width={24} height={24} /></div>);

export function MenuAfterShowNew({ link = '' }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const handleShowNew = e => {
    if (link) {
      navigate(link);
    } else {
      setSearchParams({ new: 1 });
    }
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <div className="after-button ms-auto" onClick={handleShowNew}>
      <Icons customIcon icon="square" width={24} height={24} />
    </div>
  );
}

export function MenuAfterShowNewExportImport({ path = '' }) {
  return (
    <>
      <Link to={`${path}?new=1`} title="Создать новую запись" className="after-button ms-auto"><Icons
        customIcon
        icon="square"
        width={24}
        height={24}
      />
      </Link>
      <Link to={`${path}?export=1`} title="Экспорт реестра" className="after-button"><Icons
        customIcon
        icon="download"
        width={24}
        height={24}
      />
      </Link>
      <Link to={`${path}?import=1`} title="Импорт реестра" className="after-button"><Icons
        customIcon
        icon="upload"
        width={24}
        height={24}
      />
      </Link>
    </>
  );
}

export const statusFormatter = (status, statusName = 'application.status', statusNames = APPLICATION_STATUS_NAMES) => {
  const { formatMessage } = intlShape;
  const statusClass = !Number.isNaN(status) ? statusNames[Number(status)] || 'denied' : 'denied';
  return (
    <div className={classNames('application-status', statusClass)}>
      <div className="application-status-icon">
        <Icons width={30} height={30} customIcon icon={statusClass} className="button-icons" />
      </div>
      <div className="application-status-text">
        {formatMessage({ id: `${statusName}.${status}` })}
      </div>
    </div>
  );
};

export const searchApplicantStatusFormatter = (status, statusName = 'application.status', statusNames = APPLICATION_STATUS_NAMES) => {
  const { formatMessage } = intlShape;
  const statusClass = status ? statusNames[status] || 'denied' : 'denied';
  return (
    <div className={classNames('application-status', statusClass)}>
      <div className="application-status-icon">
        <Icons width={30} height={30} customIcon icon={statusClass} className="button-icons" />
      </div>
      <div className="application-status-text">
        {formatMessage({ id: `${statusName}.${status}` })}
      </div>
    </div>
  );
};

export const stringFormatter = (status, statusName = 'application.status', statusNames = APPLICATION_STATUS_NAMES) => {
  const { formatMessage } = intlShape;
  const statusClass = statusNames[status] || 'success';
  return (
    <div className={classNames('application-status', statusClass)}>
      <div className="application-status-icon">
        <Icons width={30} height={30} customIcon icon={statusClass} className="button-icons" />
      </div>
      <div className="application-status-text">
        {formatMessage({ id: `${statusName}.${status}` })}
      </div>
    </div>
  );
};

export const szltStatusFormatter = (status, data) => statusFormatter(status, 'szlt.status', SZLT_STATUS_NAMES);

export const carrierStatusFormatter = (status, data) => statusFormatter(status, 'carrier.status', CARRIER_STATUS_NAMES);

export const vehiclesStatusFormatter = (status, data) => statusFormatter(status, 'vehicles.status', VEHICLES_STATUS_NAMES);

export const vehicleRegisterStatusFormatter = (status, data) => statusFormatter(status, 'vehicle.register.status', DICT_VEHICLE_STATUS_NAMES);

export const smevStatusOperation = status => {
  let statusName = '';
  if (status === 1) {
    statusName = 'dont-start';
  }
  if (status === 2) {
    statusName = 'success';
  }
  if (status === 3) {
    statusName = 'error';
  }
  if (status === 4) {
    statusName = 'warning';
  }
  return (
    <div className="smev-status-operation">
      <div className="smev-status-icon-wrapper">
        <div className={classNames('smev-status-icon', statusName)} />
      </div>
      <div className="smev-status-text">{localeFormatter('check.status', status)}</div>
    </div>
  );
};

export const applicationStatusOperation = (status, text) => {
  let statusName = '';
  if (status === 1) {
    statusName = 'oneDay';
  }
  if (status === 2) {
    statusName = 'twoDay';
  }
  if (status === 3) {
    statusName = 'expired';
  }
  if (status === 4) {
    statusName = 'is_archive';
  }
  return (
    <div className="application-status-operation">
      <div className="application-status-icon-wrapper">
        <div className={classNames('application-status-icon', statusName)} />
      </div>
      <div className="application-status-text">{text}</div>
    </div>
  );
};

export const infoFormatter = (l, v, formMeta = null, name = '', columns) => {
  const addProps = {};
  if (columns) {
    addProps.columns = columns;
  }

  const getFirstValue = data => {
    if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
      const firstKey = Object.keys(data)[0];
      return firstKey ? data[firstKey] : undefined;
    }
    return data;
  };
  let title = '';
  if (typeof v === 'string' || Array.isArray(v)) {
    title = Array.isArray(v) && v.length > 0 ? v?.map(e => getFirstValue(e)).join(',') : getFirstValue(v);
  }
  return (
    <Col className="info-formatter" {...addProps} title={title}>

      {formMeta ? metaDataFormatter(formMeta, name, l) : null}
      <div className="info-label">{l}</div>
      {Array.isArray(v) && v.length > 0 ? (
        <div className="info-values">
          {v.map(((item, key) => (<div key={key} className="info-value">{item || 'Нет данных'}</div>)))}
        </div>
      ) : <div className="info-value">{v || 'Нет данных'}</div>}
    </Col>
  );
};

export const infoFormatterIntl = (id, v, formMeta = null, name, columns) => {
  const { formatMessage } = intlShape;
  return infoFormatter(formatMessage({ id }), v || formatMessage({ id: 'no.data.available' }), formMeta, name, columns);
};

export const renderExtIcon = mime => {
  const ext = getExt(mime);
  const iconMap = {
    tables: ['xls', 'csv', 'ods', 'fnc'],
    images: ['png', 'jpg', 'pcx'],
    imagesByte: ['bmp', 'tif', 'gif'],
    presentations: ['key', 'pps', 'ppt'],
    pdf: ['pdf'],
    archive: ['rar', 'zip', 'tgz', 'gz'],
    docs: ['doc', 'docx', 'txt', 'rtf'],
    video: ['flv', 'mp4', 'avi', 'mkv', 'mov', 'mpg'],
  };
  const iconClass = Object.keys(iconMap).filter(key => iconMap[key].includes(ext)).join(' ');
  return (
    <div className="file-ext-icon">
      <Icons
        customIcon
        icon={ext ? 'file-ext' : 'file-ext-error'}
        className={iconClass}
      />
      <div className="file-ext-text">{ext}</div>
    </div>
  );
};

export const getLegalEntityName = item => (item && item.legal_entity_type === USER_TYPE.LEGAL ? legalNameFormatter(item) : userFIOFormatter(item));

export const legalNameFormatter = user => {
  if (user && (user.full_name || user.short_name)) {
    return user.short_name || user.full_name;
  }
  return '';
};

export const userShortFIOFormatter = user => userFIOFormatter(user, true);

export const userFIOFormatter = (user, short = false) => {
  if (user) {
    const lastName = user.last_name || user.lastName || '';
    const firstName = user.first_name || user.firstName || '';
    const middleName = user.middle_name || user.middleName || '';

    if (short) {
      const firstInitial = firstName ? `${firstName[0]}.` : '';
      const middleInitial = middleName ? `${middleName[0]}.` : '';
      return `${firstInitial}${middleInitial} ${lastName}`.trim();
    }

    return `${lastName} ${firstName} ${middleName}`.trim();
  }
  return '';
};

export const localeFormatter = (key, value) => {
  const { formatMessage } = intlShape;
  if (typeof value === 'undefined' || value === null) return '';
  return formatMessage({ id: `${key}.${value}`, defaultMessage: ' ' });
};

export const userPositionFormatter = item => (
  <div className="user-position-formatter">
    <Icons customIcon icon="user-prof" />
    <div className="user-position-formatter-info">
      <div className="user-position-formatter-name">{(item && item.full_name) || 'Автоматизация'}</div>
      {/* <div className="user-position-formatter-position">{(item && item.position) || 'Нет информации'}</div> */}
    </div>
  </div>
);

export const documentStatusFormatter = (status, data) => statusFormatter(status, 'document.status', DOCUMENT_STATUS_NAMES);

export const documentListStatusFormatter = (status, data) => {
  const statusClass = !Number.isNaN(status) && !(status === DOCUMENT_STATUS.CREATED && data?.type === 1) ? DOCUMENT_STATUS_NAMES[Number(status)] || '' : '';
  return (
    <div className="documents-status">
      <div className="documents-status-icon">
        <Icons customIcon icon={statusClass} />
      </div>
    </div>
  );
};

export const smevCheckFormatter = (_, item = {}) => {
  const { type, status } = item;
  return (
    <div className="smev-check-formatter">
      <div className={classNames('smev-check-indicator', String(getKeyByValue(CHECK_STATUS, status)).toLowerCase())} />
      <div className="smev-check-text">{type && type.name ? type.name : ''}</div>
    </div>
  );
};

export const smevCheckStatusFormatter = (_, item = {}) => {
  const { status } = item;
  return (
    <div className="smev-check-formatter">
      <div className={classNames('smev-check-indicator', String(getKeyByValue(CHECK_STATUS, status)).toLowerCase())} />
    </div>
  );
};

export const smevCheckWithContentFormatter = (content, status = '', federal_law_number = '') => (
  <div className="smev-check-formatter">
    <div className={classNames('smev-check-indicator', String(getKeyByValue(CHECK_STATUS, status)).toLowerCase())} />
    <div className="smev-check-text">{content || ''}</div>
    { federal_law_number ? federalFawFormatter(federal_law_number) : null }
  </div>
);

export const federalFawFormatter = federal_law => (
  <div className="federal-law-formatter">
    {federal_law || 'Не указан'}
  </div>
);

// export const orderServiceFormatter = (list = []) => (
//   <>
//     {
//         list.map((os, key) => (
//           <div key={key} className="application-order-service-formatter">
//             Реестровый номер: {os.order_service_number ? os.order_service_number : ''} <br />
//             Номер договора: {os.contract_number ? os.contract_number : ''} <br />
//             {os.contract_effective_date ? dateFormatter(os.contract_effective_date) : ''} - {os.contract_expiration_date ? dateFormatter(os.contract_expiration_date) : ''}
//           </div>
//         ))
//       }
//   </>
// );

export const orderServiceFormatter = (list = []) => (Array.isArray(list) ? list.map(os => (os.order_service_number ? os.order_service_number : '')).filter(f => !!f).join(', ') : []);
export const orderServiceFormatter2 = (list = []) => (Array.isArray(list) ? list.map(os => (os.number ? os.number : '')).filter(f => !!f).join(', ') : []);
export const vehiclesFormatter = (list = []) => (Array.isArray(list) ? list.map(os => (os.number ? os.number : '')).filter(f => !!f).join(', ') : []);

export const renderRegistryOption = item => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  return (
    <div className="registry-select-item">
      <div className="registry-select-text">
        <div className="registry-select-number-name">
          <div className="registry-select-number">№ {number || ''}</div>
          <div className="registry-select-name-wrapper">
            <div className="registry-select-name">{name}</div>
          </div>
        </div>
        <div className="registry-select-inn">
          ИНН: {applicant.inn} ОГРН: {applicant.ogrn} Дата: {dateFormatter(applicant.decision_date)}
        </div>
      </div>
      <div className="registry-select-status">
        {szltStatusFormatter(applicant.status)}
      </div>
    </div>
  );
};

export const renderRegistryOptionMin = item => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  const statusClass = !Number.isNaN(applicant?.status) ? SZLT_STATUS_NAMES[Number(applicant?.status)] || 'denied' : 'denied';
  const effective_date = applicant?.decision_date || applicant?.effective_date ? dateFormatter(applicant?.decision_date || applicant?.effective_date) : '';
  const expiration_date = applicant?.expiration_date ? dateFormatter(applicant?.expiration_date) : '\u221E';

  return (
    <div className={classNames('registry-select-item', statusClass)}>
      <div className="registry-select-text">
        <div className="registry-select-number-name">
          <div className="registry-select-number">№ {number || ''}</div>
          <div className="registry-select-name-wrapper">
            <div className="registry-select-name">{name || ''}</div>
          </div>
        </div>
        <div className="registry-select-inn">
          {applicant?.inn ? `ИНН: ${applicant.inn}` : ''}{applicant?.ogrn ? ` ОГРН: ${applicant.ogrn}` : ''}{` Срок действия: ${effective_date} - ${expiration_date}`}
        </div>
      </div>
    </div>
  );
};

export const renderApplicantOptionMin = (item = {}) => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  const statusClass = !Number.isNaN(applicant?.status) ? SZLT_STATUS_NAMES[Number(applicant?.status)] || 'denied' : 'denied';
  const dataList = [];
  if (applicant?.legal_entity_type || applicant?.legal_entity_type === USER_TYPE.LEGAL) {
    dataList.push(localeFormatter('user.type.short', item?.legal_entity_type));
  }
  if (applicant?.inn) {
    dataList.push(`ИНН: ${applicant.inn}`);
  }
  if (applicant?.ogrn) {
    dataList.push(`ОГРН: ${applicant.ogrn}`);
  }
  if (applicant?.created_at) {
    dataList.push(`Дата: ${dateFormatter(applicant?.created_at)}`);
  }

  return (
    <div className={classNames('registry-select-item', statusClass)}>
      <div className="registry-select-text">
        <div className="registry-select-number-name">
          <div className="registry-select-name-wrapper">
            <div className="registry-select-name">{name}</div>
          </div>
        </div>
        <div className="registry-select-inn">
          {dataList.join(' • ')}
        </div>
      </div>
    </div>
  );
};

export const renderRegistryCarrierItemMin = (item, id, onChange = () => {}, withoutInactive = true) => {
  const { applicant = {}, number = '' } = item;
  const name = getLegalEntityName(applicant);
  const statusClass = !Number.isNaN(applicant?.status) ? CARRIER_STATUS_NAMES[Number(applicant?.status)] || 'denied' : 'denied';
  const isInactive = !withoutInactive && applicant?.carrier_id !== id;
  return (
    <div className="registry-select-wrapper">
      <div className={classNames('registry-select-item', statusClass)}>
        <div className="registry-select-text">
          <div className="registry-select-number-name">
            {isInactive ? <div className="registry-select-inactive">[другой владелец]</div> : ''}
            <div className="registry-select-number"> № {number || ''}</div>
            <div className="registry-select-name-wrapper">
              <div className="registry-select-name">{name}</div>
            </div>
          </div>
          <div className="registry-select-inn">
            {applicant?.inn ? `ИНН: ${applicant.inn}` : ''}{applicant?.ogrn ? ` ОГРН: ${applicant.ogrn}` : ''}{dateFormatter(applicant?.decision_date || applicant?.effective_date) ? ` Дата: ${dateFormatter(applicant?.decision_date || applicant?.effective_date)}` : ''}
          </div>
        </div>
      </div>
      {!isInactive ? (
        <Icons
          customIcon
          className="multiple-value-delete"
          width={24}
          height={24}
          icon="close"
          onClick={event => {
            onChange(item);
            event.preventDefault();
            event.stopPropagation();
          }}
        />
      ) : null }
    </div>

  );
};

export const renderRegisterVehicleItems = items => (
  <>
    {(items || []).map((item, index) => (
      <div key={index}>
        Запись №{item?.vehicle_number}
      </div>
    ))}
  </>
);

export const renderRegisterSZLTItems = items => (
  <>
    {(items || []).map((item, index) => (
      <div key={index}>
        Запись №{item?.order_service_number}
      </div>
    ))}
  </>
);

export const subjectFormatter = (item = {}) => {
  const {
    source_subject_type, subject_type, source_subject_id, subject_id, subject, source_subject, data,
  } = item;

  const id = source_subject_id || subject_id;
  const type = source_subject_type || subject_type;
  const obj = source_subject || subject;

  return (
    <>
      {SUBJECT_TYPE.WAYBILL === type
        ? (
          <NavLink to={`/waybill?waybill_id=${id}`}>
            Путевой лист по {data?.data?.vehicle?.vehicle_lpn || 'Без номера'} от {dateFormatter(subject.waybill_dispatched_at) || 'Без даты'}
          </NavLink>
        ) : null}
      {APPLICATION_SUBJECT_TYPES.includes(type) ? (
        <NavLink to={`/application?application_id=${id}`}>
          {localeFormatter('subject.type', type)} № {obj?.mais_egu_id || 'Без номера'} от {dateFormatter(obj?.applied_at) || 'Без даты'}
        </NavLink>
      ) : null}
      {CARRIER_SUBJECT_TYPES.includes(type) ? registryLinkFormatter(`${localeFormatter('subject.type', type)} № ${obj?.number || 'Без номера'}`, REGISTRY_TYPE.CARRIER, { registry_id: id }) : null}
      {type === SUBJECT_TYPE.ORDER_SERVICE ? registryLinkFormatter(`${localeFormatter('subject.type', type)} № ${obj?.number || 'Без номера'}`, REGISTRY_TYPE.ORDER_SERVICE, { registry_id: id }) : null}
      {type === SUBJECT_TYPE.VEHICLE ? registryLinkFormatter(`${localeFormatter('subject.type', type)} № ${obj?.number || 'Без номера'}`, REGISTRY_TYPE.VEHICLE, { registry_id: id }) : null}
      {type === SUBJECT_TYPE.APPLICANT ? (
        <NavLink to={`/applicants?applicant_id=${id}`}>
          {`${localeFormatter('subject.type', type)} ${obj?.full_name || ''}`}
        </NavLink>
      ) : null}
      {type === SUBJECT_TYPE.DOCUMENT ? (
        <NavLink to={`/application/await-document?document_id=${id}`}>
          {localeFormatter('subject.type', type)} № {obj?.number || 'Без номера'} от {dateFormatter(obj?.created_at) || 'Без даты'}
        </NavLink>
      ) : null}
    </>
  );
};

export const subjectFormatterForNotification = (item = {}) => {
  const {
    source_subject_type, subject_type, source_subject_id, subject_id, subject_label, source_subject_label,
  } = item;

  const id = source_subject_id || subject_id || item?.id;
  const type = source_subject_type || subject_type || item?.type;
  const label = subject_label || source_subject_label || item?.label;

  if (APPLICATION_SUBJECT_TYPES.includes(type)) {
    return (
      <NavLink to={`/application?application_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (CARRIER_SUBJECT_TYPES.includes(type)) {
    return registryLinkFormatter(label, REGISTRY_TYPE.CARRIER, { registry_id: id });
  }

  if (type === SUBJECT_TYPE.ORDER_SERVICE) {
    return registryLinkFormatter(label, REGISTRY_TYPE.ORDER_SERVICE, { registry_id: id });
  }

  if (type === SUBJECT_TYPE.VEHICLE) {
    return registryLinkFormatter(label, REGISTRY_TYPE.VEHICLE, { registry_id: id });
  }

  if (type === SUBJECT_TYPE.VEHICLE_2) {
    return (
      <NavLink to={`/vehicle-registry?vehicle_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (type === SUBJECT_TYPE.APPLICANT) {
    return (
      <NavLink to={`/applicants?applicant_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (type === SUBJECT_TYPE.DOCUMENT) {
    return (
      <NavLink to={`/application/await-document?document_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (SUBJECT_TYPE.ROLLBACK_PLAN === type) {
    return <div>{label}</div>;
  }

  if ([SUBJECT_TYPE.WAYBILL, SUBJECT_TYPE.WAYBILL_2].includes(type)) {
    return (
      <NavLink to={`/waybill?waybill_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (SUBJECT_TYPE.VISIT === type) {
    return (
      <NavLink to={`/visits?trip_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (SUBJECT_TYPE.VIOLATION_CONTROL_WORK_DETAIL === type) {
    return (
      <NavLink to={`/violations-control-work?violation_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if ([SUBJECT_TYPE.DRIVER, SUBJECT_TYPE.DRIVER_2].includes(type)) {
    return (
      <NavLink to={`/driver-log?driver_id=${id}`}>
        {label}
      </NavLink>
    );
  }

  if (!subject_type && !source_subject_type) {
    return '';
  }

  return label;
};

export const subjectFormatterForNotificationsAdditional = (data = {}, maxCount = 2, options) => {
  const items = (data?.subjects || []).map((subject, subKey) => (<div key={`subject-${subKey}`}>{subjectFormatterForNotification(subject)}</div>)).filter((e, index) => index <= maxCount - 1);
  return (
    <div className="subject-formatter-for-notifications-additional">
      {options.type_raw === NOTIFICATION_TYPE.IMPORT ? `[${localeFormatter('import.notification', options.entity_type)}]` : ''}
      <div className="subject-formatter-for-notifications-additional-items">{items || ''}</div>
      {/* eslint-disable-next-line no-unsafe-optional-chaining */}
      {data?.subjects && data?.subjects?.length > maxCount ? `и ещё ${data?.subjects?.length - maxCount} объектов` : null}
    </div>
  );
};

export const registryLinksFormatterWithStatus = (type = '', registries = []) => (
  <div className="registry-links-formatter">
    {(registries || []).map((item, index) => (
      registryLinkFormatterWithStatus(item?.number, type, { registry_id: item?.id }, item)
    ))}
  </div>
);

export const registryLinkFormatterWithStatus = (content = '', type = '', params = {}, registry) => {
  const statusClass = registry?.status ? SZLT_STATUS_NAMES[Number(registry?.status)] || 'denied' : 'denied';
  return (
    <div className={classNames('registry-link-formatter', statusClass)}>
      {registryLinkFormatter(content, type, params)}
    </div>
  );
};

export const registryLinkFormatter = (content = '', type = '', params = {}) => {
  const searchParams = new URLSearchParams(params);

  let registryLink = '/region-registry-carrier';
  if (type === REGISTRY_TYPE.ORDER_SERVICE) {
    registryLink = '/region-registry/szlt';
  }
  if (type === REGISTRY_TYPE.VEHICLE) {
    registryLink = '/region-registry/passenger-taxi';
  }

  return (
    <NavLink
      to={{
        pathname: registryLink,
        search: searchParams.toString(),
      }}
      target="_blank"
    >
      {content}
    </NavLink>
  );
};

export const metaDataFormatter = (
  formMeta = {},
  name = '',
  label = '',
) => {
  const hasMetadata = formMeta.checks || formMeta.errors;
  if (!hasMetadata) {
    return null;
  }

  const {
    checkStatus,
    checkErrors,
    validateStatus,
    validateErrors,
  } = getFieldValidation(formMeta, name);

  const tooltipContent = (
    <div className="meta-data-information">
      <div className="meta-data-label">{label}</div>
      <div className="meta-data-row meta-data-check-errors">{checkErrors}</div>
      <div className="meta-data-row meta-data-errors">{validateErrors}</div>
    </div>
  );

  const indicatorsContent = (
    <>
      <div className={classNames('meta-data-indicator meta-data-validate-1', checkStatus)} />
      <div className={classNames('meta-data-indicator meta-data-validate-2', validateStatus)} />
    </>
  );

  return (
    <div className="meta-data">
      <TooltipWithPortal
        classNameWrapper="meta-data-dropdown"
        tooltipContent={tooltipContent}
        content={indicatorsContent}
      />
    </div>
  );
};

export const convertActivityLog = (data, key) => {
  const { formatMessage } = intlShape;
  if ((String(key).includes('_at') || String(key).includes('_date')) && typeof data === 'string') {
    return dateTimeFormatter(data);
  }
  if (key === 'order_services_attach') {
    return orderServiceFormatter(data || []);
  }
  if (Array.isArray(data)) {
    return data.map((a, i) => convertActivityLog(a, i)).join(', ');
  }
  if (data && typeof data === 'object') {
    const clearAttributes = clearActivityLog(data);
    return Object.keys(clearAttributes).map(key => `${formatMessage({ id: key, defaultMessage: key })}: ${convertActivityLog(clearAttributes[key], key)}`).join(', ');
  }
  return data || '';
};

export const clearActivityLog = (obj = {}) => Object.keys(obj).reduce((acc, key) => {
  if (String(key).includes('_label')) return acc;
  let value = obj[key];
  if (obj && typeof obj[`${key}_label`] !== 'undefined') {
    value = obj[`${key}_label`];
  }
  acc[key] = value;
  return acc;
}, {});

export const getActionLogData = activity => {
  const { formatMessage } = intlShape;
  const {
    properties = {}, subject_type, subject_id,
  } = activity;
  const { attributes = {}, old = {}, current = {} } = properties;
  const isOsgop = [SUBJECT_TYPE.APPLICATION_OSGOP_INSURANCE, SUBJECT_TYPE.CARRIER].includes(subject_type);
  const clearAttributes = clearActivityLog(attributes || {});
  const oldAttributes = clearActivityLog(old || {});
  const currentAttributes = clearActivityLog(current || {});

  return Object.keys(clearAttributes).map(key => {
    // Я этого не писал я это вынес сюда по просьбе Погребца и исправил баги)

    let keyName = key;
    const keyValue = key;
    if (key.includes('insur') && !key.includes('osgop') && isOsgop) {
      keyName = `osgop_${key}`;
    }

    if (/^order_services_attach.(\d+).contract_number/.test(key)) {
      keyName = 'contract_number';
    }

    if (/^order_services_attach.(\d+).order_service_number/.test(key)) {
      keyName = 'order_service_number';
    }

    if (/^order_services_attach.(\d+).contract_effective_date/.test(key)) {
      keyName = 'contract_effective_date';
    }

    if (/^order_services_attach.(\d+).contract_expiration_date/.test(key)) {
      keyName = 'contract_expiration_date';
    }

    if (/^osgop_insurances.(\d+).insurer/.test(key)) {
      keyName = 'insurer';
    }

    if (/^osgop_ insurances.0.(\d+).id/.test(key)) {
      keyName = 'id';
    }

    if (/^osgop_insurances.(\d+).insurance_contract_number/.test(key)) {
      keyName = 'osgop_insurance_contract_number';
    }

    if (/^osgop_insurances.(\d+).insurance_contract_effective_date/.test(key)) {
      keyName = 'osgop_insurance_contract_effective_date';
    }

    if (/^osgop_insurances.(\d+).insurance_contract_expiration_date/.test(key)) {
      keyName = 'osgop_insurance_contract_expiration_date';
    }

    if (/^osgop_insurances.(\d+).insurance_contract_series/.test(key)) {
      keyName = 'osgop_insurance_contract_series';
    }

    if (/^rejection_reason_messages.(\d+).name/.test(key)) {
      keyName = 'rejection_reason_messages.name';
    }

    if (/^rejection_reason_messages.(\d+).message/.test(key)) {
      keyName = 'rejection_reason_messages.message';
    }

    if (/^rejection_reason_messages.(\d+).additional_message/.test(key)) {
      keyName = 'rejection_reason_messages.additional_message';
    }

    if (/^rejection_reason_messages.(\d+).additional_message/.test(key)) {
      keyName = 'rejection_reason_messages.additional_message';
    }

    // Временный фикс
    const prefixes = [
      /^applicant\./,
      /^application_carrier\./,
      /^application_order_service\./,
      /^application_vehicle\./,
      /^representative\./,
      /^registry_subject\./,
    ];

    if (prefixes.some(rx => rx.test(key))) {
      keyName = key.split('.').pop();
    }

    return ({
      name: formatMessage({ id: keyName, defaultMessage: keyName }),
      prev: convertActivityLog(oldAttributes[keyValue], keyValue),
      new: convertActivityLog(clearAttributes[keyValue], keyValue),
      current: convertActivityLog(currentAttributes?.[keyValue], keyValue),
    });
  });
};

export const locationFormatter = item => {
  const { formatMessage } = intlShape;
  return (
    <div className="location-formatter">
      <div className="location-formatter-param">
        {formatMessage({ id: 'latitude' })}
        <div className="location-formatter-value">{item?.latitude}</div>
      </div>
      <div className="location-formatter-param">
        {formatMessage({ id: 'longitude' })}
        <div className="location-formatter-value">{item?.longitude}</div>
      </div>
    </div>
  );
};

export const formatFioForAvatar = user => {
  const {
    lastName, firstName, last_name, first_name,
  } = user;
  const getInitial = name => (name ? name.charAt(0).toUpperCase() : '');
  return `${getInitial(lastName || last_name)}${getInitial(firstName || first_name)}`;
};

export const infoLabelWithStatus = (status, item) => (
  <div className="info-label-with-status">
    <div className={classNames('info-label-with-status-indicator', { successful: status })} />
    <div className="info-label-with-status-value">{item}</div>
  </div>
);

export const inRegistryFormatter = yes => (
  <div className={classNames('in-registry', { yes })}>
    <Icons customIcon icon={yes ? 'green-check' : 'red-close'} /> {yes ? 'Есть' : 'Нет'}
  </div>
);

export const legalityFormatter = yes => (
  <div className={classNames('legalityFormatter', { isLegal: yes })}>
    <Icons customIcon icon={yes ? 'red-close' : 'green-check'} /> {yes ? 'Нелегально' : 'Легально'}
  </div>
);

export const inRequestInfStatusFormater = status => {
  const isSuccess = IN_REQUEST_INF_STATUS.SUCCESS === status;
  return (
    <div className={classNames('in-request-inf-status-formater', { error: !isSuccess })}>
      <Icons customIcon width={20} height={20} icon={isSuccess ? 'success' : 'denied'} />
      <div>{localeFormatter('in_request_inf.status', status)}</div>
    </div>
  );
};

export const applicantStatusFormatter = status => (
  <div className={classNames('applicant-status-formatter', { denied: status === APPLICANT_STATUS.NO_ACTIVE })}>
    <Icons customIcon icon={status === APPLICANT_STATUS.ACTIVE ? 'applicant-success' : 'applicant-denied'} />
    {localeFormatter('applicant.status', status)}
  </div>
);

export const applicantValidStatusFormatter = status => (
  <div className={classNames('applicant-status-formatter', { denied: !!status })}>
    <Icons customIcon icon={!status ? 'applicant-success' : 'applicant-denied'} />
    {localeFormatter('applicant.valid.status', +!status)}
  </div>
);

export const violationStatusFormatter = status => (
  <div className={classNames('violation-status-formatter', status)}>
    <Icons customIcon icon={status === VIOLATION_STATUS.ACTIVE ? 'applicant-success' : 'applicant-denied'} />
    {localeFormatter('violation.status', status)}
  </div>
);

export const renderValidationMessage = (errors, checkErrors, checkErrorsKeys, errorsKeys) => (
  <div className="validation-block">
    {checkErrorsKeys && checkErrorsKeys.length ? <div className="f4">Ошибки валидации полей</div> : null}
    {errorsKeys.map((e, key) => (
      <div
        key={`errors-keys-${key}`}
      >{infoFormatterIntl(String(e).split('.').pop(), propsToRow(errors[e]?.messages || ''))}
      </div>
    ))}
    {checkErrorsKeys && Object.values(checkErrors).filter(f => f.status !== 2).length ? <div className="f4 mt-3">Ошибки валидации РСМЭВ</div> : null}
    {checkErrorsKeys.map((e, key) => {
      if (checkErrors[e].status === 2) { return null; }
      return (<div key={`check-errors-keys-${key}`}>{infoFormatterIntl(String(e).split('.').pop(), propsToRow((checkErrors[e]?.errors || []).map(ei => ei?.message || '').filter(f => !!f).join(', ') || ''))}</div>);
    })}
  </div>
);

export const renderRegistryValidationMessage = (errors, checkErrors, checkErrorsKeys, errorsKeys) => (
  <div className="validation-block">
    {checkErrorsKeys.map((e, key) => {
      if (checkErrors[e].status === 2) { return null; }
      return (<div key={`check-errors-keys-${key}`}>{infoFormatterIntl(String(e).split('.').pop(), propsToRow((checkErrors[e]?.errors || []).map(ei => ei?.message || '').filter(f => !!f).join(', ') || ''))}</div>);
    })}
    {errorsKeys.map((e, key) => (
      <div
        key={`errors-keys-${key}`}
      >{infoFormatterIntl(String(e).split('.').pop(), propsToRow(errors[e]?.messages || ''))}
      </div>
    ))}
  </div>
);

export const formatRegistryNumber = (numbers = [], registry_subjects, registry_subject, registryType, fieldsValidation, keyPrefix = '') => {
  const hasMultipleSubjects = registry_subjects && registry_subjects.length > 0;

  const translationKey = (keyPrefix ? `${keyPrefix}.` : '') + (hasMultipleSubjects ? 'registry.numbers' : 'registry.number');
  const fieldName = hasMultipleSubjects ? 'numbers' : 'number';
  const isNoData = !numbers.length;
  const dataRender = (numbers || []).map((n, key) => {
    const item = (registry_subjects || []).find(i => i.number === n);
    return (
      <div key={key}>
        {registryLinkFormatter(
          renderRegistryOptionMin({ applicant: { ...item }, number: item?.number || n }),
          registryType,
          { registry_id: item?.id },
        )}
      </div>
    );
  });
  return infoFormatterIntl(
    translationKey,
    <div className="registry-number-list">
      {isNoData ? 'Данные отсутствуют' : dataRender}
    </div>,
    fieldsValidation,
    fieldName,
  );
};
